import { z } from 'zod';
import { QTY_SCALE } from '../../utils/quantity-scale.js';
import { priorityIdSchema } from '../priority/index.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
import { splitQuantitiesSchema } from './split-quantities.js';
export const manufacturingOrderLineInputSchema = z.object({
    partId: requiredUuidString(`${MANUFACTURING_ORDER_CONSTRAINTS.part.label} is required.`, 'Invalid part selection.'),
    // WHY: below Decimal(28,9)'s scale a positive value rounds to 0 in storage, so re-check positivity after rounding, same as splitQuantitiesSchema.
    quantity: z
        .number()
        .finite(`${MANUFACTURING_ORDER_CONSTRAINTS.quantity.label} must be a finite number.`)
        .positive(`${MANUFACTURING_ORDER_CONSTRAINTS.quantity.label} must be greater than zero.`)
        .max(MANUFACTURING_ORDER_CONSTRAINTS.quantity.max, `${MANUFACTURING_ORDER_CONSTRAINTS.quantity.label} must be ${MANUFACTURING_ORDER_CONSTRAINTS.quantity.max.toLocaleString('en-US')} or less.`)
        .transform((value) => Math.round(value * QTY_SCALE) / QTY_SCALE)
        .refine((value) => value > 0, `${MANUFACTURING_ORDER_CONSTRAINTS.quantity.label} must be greater than zero.`),
    name: z
        .string()
        .trim()
        .min(1, `${MANUFACTURING_ORDER_CONSTRAINTS.name.label} is required.`)
        .max(MANUFACTURING_ORDER_CONSTRAINTS.name.maxLength, `${MANUFACTURING_ORDER_CONSTRAINTS.name.label} must be ${MANUFACTURING_ORDER_CONSTRAINTS.name.maxLength} characters or fewer.`),
    // WHY: null is how a cleared split serialises over GraphQL, so it must mean the same as omitted.
    splitQuantities: splitQuantitiesSchema.nullish().transform((value) => value ?? []),
    // Absent is the ordinary case: a line without one leaves every ticket cut from it to release,
    // which resolves an unanswered ticket to Normal.
    priorityId: priorityIdSchema.nullish().transform((value) => value ?? null),
});
//# sourceMappingURL=line-input.js.map